<script setup></script>

<template>
  <footer class="page-layout__footer page-footer">
    <div class="page-footer__copyright">
      Разработчик:
      <a class="ui-kit__a" href="https://infocom.kg/" target="_blank"
        >Государственное предприятие «Инфоком»</a
      >
      <br />
      © Зарегистрирован в Государственном реестре программ для ЭВМ Кыргызской
      Республики от 26.09.2018 года, сертификат за № 525
    </div>
  </footer>
</template>
